<template>
    <div class="feature col-lg-6">
        <div class="icon mr-2"><fa-icon :icon="icon" /></div>
        <div class="px-4">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        icon: {type: Array, required: true}
    }
}
</script>

<style lang="scss" scoped>
    .feature {
        padding-top: 1.5rem;
        padding-bottom: 1.5rem;
        display: flex;

        h5 {
            color: $primary;
            margin-bottom: .75rem;
            //font-family: $font-family-poppins-first;
            font-weight: bold;
        }

        line-height: 1.75;

        .icon {
            border-radius: 50%;
            min-width: 65px;
            height: 65px;
            line-height: 65px;
            text-align: center;
            color: var(--secondary);
            box-shadow: 0 2px 4px rgba(#212529, .1), 0 7px 14px rgba(#212529, .1);
            font-size: 27px;
        }
    }
</style>
